import './App.css';
import SFEOSMap from './SFEOSMap';

function App() {
  return (
    <div className="App">
      <SFEOSMap />
    </div>
  );
}

export default App;
